import styles from './index.less';

const CustomerService = () => {
    return <div className={styles.customerServiceBox}>
        <img className={styles.qrCode} src='https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/zhifuchenggongjiakefu-erweima@2x.png' />
        <div className={styles.desc}>如有疑问<br />请添加专属客服</div>
    </div>
};

export default CustomerService;